module.exports = __webpack_public_path__ + "media/images/seats-8a76055730669a600eee470c935c28e1.png";